(function () {
    const OFFER_TYPES = window.OFFER_TYPES || {};
    const offerType = window.determineOfferType ? window.determineOfferType() : window.offerType;
    const urlParams = new URLSearchParams(location.search);
    var r = urlParams.get('r');
    const offerId = urlParams.get('id');
    const apts = urlParams.get('apts');
    const keepsakeReminder = urlParams.get('krmnd');
    const orderId = urlParams.get('orderId');
    const cacheBustVersion = urlParams.get('v');
    const showSnippetLoader = String(urlParams.get('sl') || '').toLowerCase() === 'true';
    const pageOrigin = window.location.origin;
    const pagePath = window.location.pathname;
    const isOfferTypeIdentified = Boolean(offerType);
    const parsedDogIdFromReferral = r ? String(r).split('|')[0] : '';

    function hasResolvedOfferData() {
        return Boolean(
            window._submissionOfferAssembly ||
            window._assignmentOffer ||
            window._submissionOffer ||
            window._offer ||
            window.offerType
        );
    }

    function cacheDogIdFromUniversalOffer() {
        if (
            isOfferTypeIdentified ||
            !parsedDogIdFromReferral ||
            !hasResolvedOfferData()
        ) {
            return;
        }

        if (typeof window.setDogIDCookie === 'function') {
            window.setDogIDCookie(parsedDogIdFromReferral);
            return;
        }

        try {
            localStorage.setItem('dog_id', parsedDogIdFromReferral);
        } catch (error) {
            // Ignore storage failures.
        }
    }

    function findPrimaryImageContainer() {
        return (
            document.querySelector('.gp-feature-image-carousel .gp-image-item div:first-child') ||
            document.querySelector('.main-product__media-gallery')
        );
    }

    function applySnippetLoader() {
        const mediaGallery = findPrimaryImageContainer();
        if (!mediaGallery) {
            return false;
        }
        const imgEl = mediaGallery.querySelector('img');
        if (imgEl) {
            window.cachedImgEl = imgEl;
            if (imgEl.style) {
                imgEl.style.opacity = '0';
            }
        }

        mediaGallery.style.textAlign = 'center';

        if (window.getComputedStyle(mediaGallery).position === 'static') {
            mediaGallery.style.position = 'relative';
        }

        let loader = mediaGallery.querySelector('.loader.tpp-snippet-loader');
        if (!loader) {
            loader = document.createElement('div');
            loader.className = 'loader tpp-snippet-loader';
            loader.style.position = 'absolute';
            loader.style.top = '50%';
            loader.style.left = '50%';
            loader.style.transform = 'translate(-50%, -50%)';
            loader.style.margin = '0';
            loader.style.zIndex = '10';
            mediaGallery.appendChild(loader);
        }

        return true;
    }

    if (showSnippetLoader) {
        const appliedImmediately = applySnippetLoader();
        if (!appliedImmediately) {
            window.addEventListener('DOMContentLoaded', applySnippetLoader, { once: true });
            window.addEventListener('load', applySnippetLoader, { once: true });
        }
    }

    if (!r) {
        const localStoreDogId = localStorage.getItem('dog_id');

        const soIdForPath = window.getSubmissionOfferForCurrentPage();

        const cachedAssignmentOfferId = localStorage.getItem('url_assignment_offer_id');

        if (localStoreDogId) {
            r = `${localStoreDogId}`;

            if (soIdForPath) {
                r += `|${soIdForPath}`;
            } else if (cachedAssignmentOfferId) {
                r += `|${cachedAssignmentOfferId}`;
            }
        }
    }

    window.loadingAssemblyOfferViaScript = true;

    window.addEventListener('tppData:ready', () => {
        console.log('TPP Data is ready');
        cacheDogIdFromUniversalOffer();
    });

    var s = document.createElement('script');
    s.onload = function () {
        cacheDogIdFromUniversalOffer();
    };
    s.src =
        'https://apif.thepawprint.store/snippets/offers' +
        '?dog_id=' +
        encodeURIComponent(r) +
        '&offer_type=' +
        encodeURIComponent(offerType) +
        '&page_origin=' + encodeURIComponent(pageOrigin) +
        '&page_path=' + encodeURIComponent(pagePath) +
        (offerId && offerId != 'null' ? '&offer_id=' + encodeURIComponent(offerId) : '') +
        (offerType === OFFER_TYPES.KEEPSAKE_PORTRAIT && apts ? '&apts=' + encodeURIComponent(apts) : '') +
        (offerType === OFFER_TYPES.KEEPSAKE_PORTRAIT && keepsakeReminder ? '&krmnd=' + encodeURIComponent(keepsakeReminder) : '') +
        (offerType === OFFER_TYPES.KEEPSAKE_PORTRAIT && orderId ? '&order_id=' + encodeURIComponent(orderId) : '') +
        (cacheBustVersion ? '&v=' + encodeURIComponent(cacheBustVersion) : '');
    // If you need it ASAP, don't defer. If it can wait, set defer=true.
    document.head.appendChild(s);
})();
